export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_convey-pro-1/artifacts/366kv7es_Logo-%20transparent%20background.png";

// Team headshots
export const MADDI_HEADSHOT =
  "https://customer-assets.emergentagent.com/job_convey-pro-1/artifacts/7d72yhp2_Maddi%20headshot.png";
export const MEGAN_HEADSHOT =
  "https://customer-assets.emergentagent.com/job_convey-pro-1/artifacts/0djqcq1k_Megan%20Headshot.png";

// Coastal imagery — Sunshine Coast aesthetic
export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1473116763249-2faaef81ccda?auto=format&fit=crop&w=2400&q=85";
export const ABOUT_HERO =
  "https://customer-assets.emergentagent.com/job_convey-pro-1/artifacts/27suh0wz_about%20page%20sunshine%20coast.jpg";
export const PROPERTY_IMAGE =
  "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=2000&q=80";
export const COMMERCIAL_IMAGE =
  "https://customer-assets.emergentagent.com/job_convey-pro-1/artifacts/4krv02uf_correct%20commercial%20property%20image.png";
export const OFFICE_IMAGE =
  "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=2400&q=85";
export const SERVICES_CONTACT_HERO =
  "https://customer-assets.emergentagent.com/job_convey-pro-1/artifacts/vlp18oiv_a-%20Noosa%20beach.png";
export const BUSINESS_IMAGE =
  "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=2000&q=80";
export const COASTAL_HOME =
  "https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?auto=format&fit=crop&w=2000&q=80";

export const POSTAL = {
  line1: "PO Box 1240",
  line2: "Buddina QLD 4575",
  country: "Australia",
};

export const PRACTICE_CONTACTS = {
  commercial: {
    area: "Commercial Property & Business",
    label: "Commercial Property & Business Enquiries",
    name: "Maddison Bellhouse",
    phone: "0422 016 186",
    email: "maddison@bellhouselaw.com.au",
  },
  residential: {
    area: "Residential Conveyancing",
    label: "Residential Conveyancing Enquiries",
    name: "Megan Thompson",
    phone: "0488 382 862",
    email: "megan@bellhouselaw.com.au",
  },
};

export const FIRM = {
  name: "Bellhouse Law",
  short: "Bellhouse",
  tagline: "Practical advice, proven results.",
  email: PRACTICE_CONTACTS.commercial.email,
  phone: PRACTICE_CONTACTS.commercial.phone,
  hours: "Monday – Friday, 8:30am – 5:00pm",
  social: {
    linkedin: "#",
    instagram: "#",
    facebook: "#",
  },
  intakeIframe:
    "https://matter-intake.com.au/create/500eaade-8805-4a7c-991d-31d5a1cce76b",
};

export const VALUES = [
  {
    title: "Clear",
    body: "Plain language, no jargon and no surprises. We translate legal complexity into decisions you can actually make.",
  },
  {
    title: "Responsive",
    body: "Direct access to your file handler. Prompt communication and regular updates throughout every matter.",
  },
  {
    title: "Commercial",
    body: "Every clause exists to serve a real-world outcome. We design legal solutions around commercial reality.",
  },
  {
    title: "Principled",
    body: "Discreet, considered and ethical. Our reputation is built on the long view of every relationship.",
  },
];

export const TEAM = [
  {
    name: "Maddison Bellhouse (née Smith)",
    role: "Founder & Principal",
    image: MADDI_HEADSHOT,
    bio: [
      "Bellhouse Law was founded by Maddison Bellhouse with a simple goal, to provide clear, practical legal advice that gives clients confidence to make informed decisions.",
      "Maddison is a commercial lawyer with over six years' experience advising individuals, businesses, investors and developers across a wide range of commercial and property matters. Her practice includes residential and commercial conveyancing, commercial and retail leasing, business sales and acquisitions, shareholder agreements, and employment and HR advice.",
      "A First Class Honours graduate from the University of the Sunshine Coast and admitted to the Supreme Court of Queensland, Maddison is known for her practical approach, responsive communication and commercially focused advice. She has managed legal teams, developed efficient legal systems and presented at the Australian Human Resources Institute (AHRI) Conference on employment law.",
    ],
  },
  {
    name: "Megan Thompson",
    role: "Conveyancing Manager",
    image: MEGAN_HEADSHOT,
    bio: [
      "Megan Thompson is Bellhouse Law's Conveyancing Manager and brings more than 25 years of experience in Queensland conveyancing. She has extensive expertise in residential conveyancing, retirement living transactions, manufactured home agreements and off-the-plan property matters.",
      "Throughout her career, Megan has managed conveyancing teams across multiple firms, overseen thousands of property transactions and built a reputation for delivering efficient, client-focused service. Her extensive referral network and strong industry relationships have made her a trusted professional within the property sector.",
      "Megan's commitment to excellence has been recognised through six consecutive Business Network International (BNI) MVP Awards, together with Ambassador of the Year (2024) and Director Consultant of the Year (2025). She has also contributed to the development of the Commonwealth Bank of Australia home lending platform in Queensland, demonstrating her practical expertise and deep understanding of conveyancing systems and processes.",
    ],
  },
];

export const SERVICES = [
  {
    slug: "residential-conveyancing",
    title: "Residential Conveyancing",
    short:
      "Calm, considered guidance through every stage of buying or selling a property.",
    image: PROPERTY_IMAGE,
    contact: PRACTICE_CONTACTS.residential,
    overview:
      "From the first offer to settlement day, our conveyancing team makes the legal side of moving feel quiet and controlled. We handle contract review, searches, special conditions, finance milestones, and settlement, communicating clearly at every step so you always know what is happening next.",
    keyServices: [
      "Contract of Sale review and amendment",
      "Pre-contract due diligence and title searches",
      "Special condition drafting and negotiation",
      "Self-managed super fund assistance",
      "PEXA electronic settlements",
      "Off-the-plan and new build purchases",
      "Transfers between related parties",
      "First home buyer assistance",
    ],
    benefits: [
      "Fixed-fee pricing with no surprises",
      "Direct communication with your team from start to finish",
      "Fast contract reviews when timing matters most",
      "Clear, plain-English advice you can understand",
    ],
    faqs: [
      {
        q: "How long does a typical settlement take?",
        a: "Most residential settlements in Queensland complete within 30 to 45 days from contract date, though we routinely accommodate shorter or longer windows depending on your finance and life circumstances.",
      },
      {
        q: "When should I engage a conveyancer?",
        a: "Ideally before you sign, even one pass over the draft contract can save tens of thousands. If you have already signed, contact us within your cooling-off period so we can act quickly.",
      },
      {
        q: "Do you offer fixed fees?",
        a: "Yes. We quote a fixed professional fee for standard transactions and clearly itemise third-party disbursements so there are no surprises at settlement.",
      },
      {
        q: "Can you settle remotely?",
        a: "Absolutely. We are fully PEXA-enabled and most of our clients complete their entire transaction without setting foot in our office.",
      },
    ],
  },
  {
    slug: "commercial-property",
    title: "Commercial Property",
    short:
      "Practical legal advice for commercial property transactions, leasing and development.",
    image: COMMERCIAL_IMAGE,
    contact: PRACTICE_CONTACTS.commercial,
    overviewHeading: "Commercial property advice with commercial outcomes.",
    overview:
      "Commercial property transactions require more than preparing documents. Whether you are buying, selling, leasing or developing commercial property, we provide practical advice that protects your position and keeps transactions moving efficiently. We act for investors, business owners, landlords, tenants and developers across Queensland, providing commercially focused advice from contract through to settlement.",
    keyServicesHeading: "What we can help with:",
    keyServices: [
      "Commercial property acquisitions and sales",
      "Commercial and retail leasing",
      "Lease drafting, negotiation and review",
      "Development and subdivision transactions",
      "Body corporate and community titles matters",
      "Due diligence and contract advice",
      "Off-the-plan commercial developments",
    ],
    benefits: [
      "Commercially focused advice from contract to settlement",
      "Direct communication with your team throughout the transaction",
      "Efficient turnaround on contracts and leasing matters",
      "Practical advice tailored to your commercial objectives",
    ],
    faqs: [],
  },
  {
    slug: "business",
    title: "Business",
    short:
      "Practical legal advice to help businesses grow, protect their assets and manage their people.",
    image: BUSINESS_IMAGE,
    contact: PRACTICE_CONTACTS.commercial,
    overviewHeading: "Supporting businesses through every stage.",
    overview:
      "Whether you are buying or selling a business, restructuring your company, preparing shareholder agreements or managing employees, we provide clear, commercially practical legal advice that supports your long-term success. Our focus is on practical outcomes, helping business owners make informed decisions with confidence.",
    keyServicesHeading: "What we can help with:",
    keyServices: [
      "Business sales and purchases",
      "Shareholder agreements",
      "Partnership agreements",
      "Employment contracts",
      "Contractor agreements",
      "Workplace policies and procedures",
    ],
    benefits: [
      "Commercial advice focused on practical business outcomes",
      "Direct access to experienced legal advice",
      "Clear fixed-fee pricing wherever possible",
      "Long-term legal support as your business grows",
    ],
    faqs: [],
  },
];
